/*!

=========================================================
* Argon Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Event from "../lib/Event";
//import FirebaseUtils from "lib/FirebaseUtils";
import PubSub from "../lib/PubSub";
import React from "react";
import { Link, withRouter } from "react-router-dom";
import _ from "underscore";
import {
  IonCard,
  IonCardContent,
  IonGrid,
  IonCol,
  IonRow,
  IonButton,
  IonIcon,
} from "@ionic/react";

import glutenFree from "../assets/img/icons/gluten_free.svg";
import { add, information, remove } from "ionicons/icons";
import StringUtils from "../lib/StringUtils";
import SegmentUtils from "../lib/SegmentUtils";
import { Haptics, ImpactStyle } from "@capacitor/haptics";
import { Capacitor } from "@capacitor/core";

import chicken from "../assets/img/icons/protein_chicken_noborder.svg";
import beef from "../assets/img/icons/protein_beef_noborder.svg";
import pork from "../assets/img/icons/protein_pork_noborder.svg";
import turkey from "../assets/img/icons/protein_turkey_noborder.svg";
import plant from "../assets/img/icons/protein_plant_noborder.svg";
import egg from "../assets/img/icons/protein_egg_noborder.svg";
import other from "../assets/img/icons/protein_other_noborder.svg";
import fish from "../assets/img/icons/protein_fish_noborder.svg";

class MealOptionCardNoSelection extends React.Component<{
  mobile?: boolean;
  meal?: any;
  selected?: any;
  disableAdd?: boolean;
  incrementMeal?: any;
  compact?: boolean;
  checkoutMode?: boolean;
  modalID?: string;
  position?: number;
}> {
  state: any = {};

  openMealInfo(meal: any) {
    if (this.props.checkoutMode) {
      return;
    }

    // Haptic feedback
    if (Capacitor.isNativePlatform()) {
      Haptics.impact({ style: ImpactStyle.Medium });
    }

    let props: any = {
      brand: "Project LeanNation",
      category: meal?.planType?.name + " Meals",
      image_url: meal?.imageURL,
      name: meal?.name,
      product_id: meal?._id,
      url: meal?.deeplinkURL,
    };

    if (this.props.position) {
      props.position = this.props.position;
    }

    SegmentUtils.track("Product Clicked", props);

    PubSub.publish(Event.MEAL.OPEN_INFO, { meal, id: this.props.modalID });
  }

  renderTopCategory(meal: any) {
    let top: any = "";
    let priority = 0;

    if (!meal?.categories?.length) {
      top = (
        <div
          color="info"
          className="px-sm-2 px-1 py-1 bg-white text-uppercase text-dark font-weight-bold"
          style={{
            fontSize: this.props.mobile ? 11 : "12px",
            borderRadius: "3px",
            border: "1px solid var(--light)",
          }}
        >
          Balanced
        </div>
      );

      return top;
    }

    for (let i = 0; i < meal.categories.length; i++) {
      let cat = meal.categories[i];

      if (cat.name == "Lean Cheats" && priority <= 100) {
        top = (
          <div
            color="danger"
            className="px-sm-2 px-1 py-1 bg-white text-dark text-uppercase font-weight-bold"
            style={{
              fontSize: this.props.mobile ? 11 : "12px",
              borderRadius: "3px",
              border: "1px solid var(--light)",
            }}
          >
            {cat.name}
          </div>
        );
        priority = 100;
      }

      if (cat.name == "Plant Based" && priority <= 90) {
        top = (
          <div
            color="success"
            className="px-sm-2 px-1 py-1 bg-white text-dark text-uppercase font-weight-bold"
            style={{
              fontSize: this.props.mobile ? 11 : "12px",
              borderRadius: "3px",
              border: "1px solid var(--light)",
            }}
          >
            {cat.name}
          </div>
        );
        priority = 90;
      }

      if (cat.name == "Grain Free" && priority <= 80) {
        top = (
          <div
            color="warning"
            className="px-sm-2 px-1 py-1 bg-white text-uppercase text-dark font-weight-bold"
            style={{
              fontSize: this.props.mobile ? 11 : "12px",
              borderRadius: "3px",
              border: "1px solid var(--light)",
            }}
          >
            {cat.name}
          </div>
        );
        priority = 80;
      }

      if (cat.name == "Dairy Free" && priority <= 70) {
        top = (
          <div
            color="info"
            className="px-sm-2 px-1 py-1 bg-white text-uppercase text-dark font-weight-bold"
            style={{
              fontSize: this.props.mobile ? 11 : "12px",
              borderRadius: "3px",
              border: "1px solid var(--light)",
            }}
          >
            {cat.name}
          </div>
        );
        priority = 70;
      }
    }

    if (!top) {
      top = (
        <div
          color="info"
          className="px-sm-2 px-1 py-1 bg-white text-uppercase text-dark font-weight-bold"
          style={{
            fontSize: this.props.mobile ? 11 : "12px",
            borderRadius: "3px",
            border: "1px solid var(--light)",
          }}
        >
          Balanced
        </div>
      );
    }

    return top;
  }

  getSegmentProps() {
    let props: any = {
      brand: "Project LeanNation",
      category: this.props.meal?.planType?.name + " Meals",
      image_url: this.props.meal?.imageURL,
      name: this.props.meal?.name,
      product_id: this.props.meal?._id,
      url: this.props.meal?.deeplinkURL,
      quantity: 1,
    };

    if (this.props.position) {
      props.position = this.props.position;
    }

    return props;
  }

  getProteinIcon(meal: any) {
    if (!meal?.primaryProteinCategory) {
      return "";
    }

    const cat = meal?.primaryProteinCategory?.toLowerCase();

    if (cat == "chicken") {
      return chicken;
    }

    if (cat == "beef") {
      return beef;
    }

    if (cat == "pork") {
      return pork;
    }

    if (cat == "turkey") {
      return turkey;
    }

    if (cat == "fish") {
      return fish;
    }

    if (cat == "plant based") {
      return plant;
    }

    if (cat == "lean cheat") {
      return other;
    }

    if (cat == "egg") {
      return egg;
    }
  }

  isInSelected(meal: any) {
    let i = _.findWhere(this.state.selectedMeals, { _id: meal._id });

    if (i) {
      return true;
    }

    return false;
  }

  stripHTML(html: any) {
    return html.replace(/(<([^>]+)>)/gi, "");
  }

  convertToPlain(html: any) {
    return StringUtils.htmlToText(html);
  }

  render() {
    return (
      <>
        {this.props.mobile ? (
          <>
            <IonCard
              mode="ios"
              className="m-0 meal-info-card "
              style={{
                borderRadius: 0,
                boxShadow: "none",
              }}
            >
              <IonCardContent
                className="p-0 bg-white rounded-lg border-[1px] md:border-[0px] border-gray-100"
                style={{}}
              >
                <div className="d-flex">
                  <div
                    className={`p-2 ${
                      !this.props.checkoutMode && "cursor-pointer"
                    }`}
                    style={{
                      width: `calc(100% - ${
                        this.props.checkoutMode
                          ? "80px"
                          : Capacitor.getPlatform() == "ios"
                          ? "130px"
                          : "115px"
                      })`,
                    }}
                  >
                    <div onClick={() => this.openMealInfo(this.props.meal)}>
                      <div className={`mb-1 ${this.props.compact && "d-none"}`}>
                        <div className="flex items-center">
                          <div className="pl-0 py-0 grow">
                            <div
                              className={`${
                                this.props.meal?.retired
                                  ? "sm:flex gap-x-2 lg:block gap-y-1"
                                  : "inline-block"
                              }`}
                            >
                              {this.props.meal?.retired ? (
                                <>
                                  <div
                                    className={`inline-block mr-[0.45rem] sm:mr-0 px-sm-2 bg-yellow-200 border-[1px] border-yellow-900 text-gray-900 font-weight-700 text-uppercase ${
                                      !this.props.mobile && "px-1 py-[0.1rem]"
                                    }`}
                                    style={{
                                      fontSize: this.props.mobile ? 11 : "12px",
                                      borderRadius: "3px",

                                      paddingLeft: this.props.mobile
                                        ? "0.2rem"
                                        : "",
                                      paddingRight: this.props.mobile
                                        ? "0.2rem"
                                        : "",
                                      paddingTop: this.props.mobile
                                        ? "0.15rem"
                                        : "",
                                      paddingBottom: this.props.mobile
                                        ? "0.15rem"
                                        : "",
                                    }}
                                  >
                                    Limited Time
                                  </div>
                                </>
                              ) : null}
                              <div className="flex gap-x-2 d-inline-block">
                                {this.renderTopCategory(this.props.meal)}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div>
                        <h3
                          className={`${
                            !this.props.compact && "pt-[0.3rem]"
                          } mb-0 text-truncate text-dark font-medium font-[SourceSerif] ${
                            this.props.checkoutMode &&
                            "d-flex ion-align-items-center"
                          }`}
                          style={{ fontSize: 18 }}
                        >
                          <div
                            style={{
                              flexGrow: this.props.checkoutMode ? "1" : "",
                              whiteSpace: this.props.checkoutMode
                                ? "unset"
                                : "normal",
                            }}
                            className={
                              this.props.checkoutMode ? "text-truncate" : ""
                            }
                          >
                            {this.props.meal.name}
                          </div>
                          {this.props.checkoutMode && (
                            <>
                              <div className="ml-1 flex items-center">
                                {this.props.meal?.retired ? (
                                  <>
                                    <div
                                      className={`inline-block font-[Karla] mr-[0.45rem] sm:mr-0 px-sm-2 bg-yellow-200 border-[1px] border-yellow-900 text-gray-900 font-weight-700 text-uppercase ${
                                        !this.props.mobile && "px-1 py-[0.1rem]"
                                      }`}
                                      style={{
                                        fontSize: this.props.mobile
                                          ? 11
                                          : "12px",
                                        borderRadius: "3px",

                                        paddingLeft: this.props.mobile
                                          ? "0.2rem"
                                          : "",
                                        paddingRight: this.props.mobile
                                          ? "0.2rem"
                                          : "",
                                        paddingTop: this.props.mobile
                                          ? "0.15rem"
                                          : "",
                                        paddingBottom: this.props.mobile
                                          ? "0.15rem"
                                          : "",
                                      }}
                                    >
                                      Limited Time Only
                                    </div>
                                  </>
                                ) : null}
                                <div
                                  className="px-1 py-1 bg-gray-50 d-inline-block items-center text-gray-900 font-weight-bold border-[1px] d-inline-block border-gray-100 text-uppercase"
                                  style={{
                                    fontSize: this.props.checkoutMode ? 10 : 11,
                                    lineHeight: 1,
                                    borderRadius: 3,
                                  }}
                                >
                                  <div className="flex gap-x-1 items-center">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      className="h-3 w-3"
                                    >
                                      <circle cx="12" cy="12" r="10" />
                                      <path d="M12 16v-4" />
                                      <path d="M12 8h.01" />
                                    </svg>
                                    <div>Info</div>
                                  </div>
                                </div>
                                {this.props.selected > 0 ? (
                                  <div
                                    className="px-1 ml-2 py-1 bg-dark text-white font-weight-bold border d-inline-block border-dark text-uppercase"
                                    style={{
                                      fontSize: this.props.checkoutMode
                                        ? 10
                                        : 11,
                                      lineHeight: 1,
                                      borderRadius: 3,
                                    }}
                                  >
                                    {this.props.selected} In Box
                                  </div>
                                ) : null}
                              </div>
                            </>
                          )}
                        </h3>
                        <div
                          className={`meal-info-description mt-1 ${
                            this.props.checkoutMode && "compact"
                          }`}
                        >
                          {this.convertToPlain(this.props.meal.description)}
                        </div>
                        <div className={`grow`}>
                          <IonRow className="">
                            <IonCol size-xs="auto" className="pr-[0.8rem] pl-0">
                              <div className="text-center">
                                <p
                                  className="text-lowercase text-dark font-weight-bold mb-0"
                                  style={{ fontSize: 16, lineHeight: 1.3 }}
                                >
                                  {this.props.meal?.nutrition?.calories}
                                </p>
                                <p
                                  className="text-dark font-medium m-0"
                                  style={{ fontSize: "11px", lineHeight: 1 }}
                                >
                                  Calories
                                </p>
                              </div>
                            </IonCol>
                            <IonCol size-xs="auto" className="pr-[0.8rem] pl-0">
                              <div className="text-center">
                                <p
                                  className="text-lowercase text-dark font-weight-bold mb-0"
                                  style={{ fontSize: 16, lineHeight: 1.3 }}
                                >
                                  {this.props.meal?.nutrition?.protein}g
                                </p>
                                <p
                                  className="text-dark font-medium m-0"
                                  style={{ fontSize: "11px", lineHeight: 1 }}
                                >
                                  Protein
                                </p>
                              </div>
                            </IonCol>
                            <IonCol size-xs="auto" className="pr-[0.8rem] pl-0">
                              <div className="text-center">
                                <p
                                  className="text-lowercase text-dark font-weight-bold mb-0"
                                  style={{ fontSize: 16, lineHeight: 1.3 }}
                                >
                                  {this.props.meal?.nutrition?.carbs}g
                                </p>
                                <p
                                  className="text-dark font-medium m-0"
                                  style={{ fontSize: "11px", lineHeight: 1 }}
                                >
                                  Carbs
                                </p>
                              </div>
                            </IonCol>
                            <IonCol size-xs="auto" className="pr-0 pl-0">
                              <div className="text-center">
                                <p
                                  className="text-lowercase text-dark font-weight-bold mb-0"
                                  style={{ fontSize: 16, lineHeight: 1.3 }}
                                >
                                  {this.props.meal?.nutrition?.fat}g
                                </p>
                                <p
                                  className="text-dark font-medium m-0"
                                  style={{ fontSize: "11px", lineHeight: 1 }}
                                >
                                  Fats
                                </p>
                              </div>
                            </IonCol>
                          </IonRow>
                        </div>
                      </div>
                    </div>
                    <div
                      className={`${
                        this.props.compact && "d-none"
                      } flex items-center`}
                    >
                      <div
                        className={`${
                          this.props.compact && !this.props.checkoutMode
                            ? "d-block mt-1"
                            : "d-none"
                        }`}
                      >
                        <IonGrid className="p-0">
                          <IonRow className="ion-ion-align-items-center">
                            <IonCol
                              className="pr-0 py-0 text-right flex items-center justify-end"
                              size-xs="12"
                            >
                              <div
                                className="px-1 py-1 bg-gray-50 d-inline-block items-center text-gray-900 font-weight-bold border-[1px] d-inline-block border-gray-100 text-uppercase"
                                style={{
                                  fontSize: this.props.checkoutMode ? 10 : 11,
                                  lineHeight: 1,
                                  borderRadius: 3,
                                }}
                              >
                                <div className="flex gap-x-1 items-center">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    className="h-3 w-3"
                                  >
                                    <circle cx="12" cy="12" r="10" />
                                    <path d="M12 16v-4" />
                                    <path d="M12 8h.01" />
                                  </svg>
                                  <div>Info</div>
                                </div>
                              </div>
                              {this.props.selected > 0 ? (
                                <div
                                  className="px-1 ml-2 py-1 bg-dark text-white font-weight-bold border d-inline-block border-dark text-uppercase"
                                  style={{
                                    fontSize: this.props.checkoutMode ? 10 : 11,
                                    lineHeight: 1,
                                    borderRadius: 3,
                                  }}
                                >
                                  {this.props.selected} In Box
                                </div>
                              ) : null}
                            </IonCol>
                          </IonRow>
                        </IonGrid>
                      </div>
                    </div>
                  </div>
                  <div
                    onClick={() => this.openMealInfo(this.props.meal)}
                    className={`mt-0 mb-0 mr-0 mr-0 rounded-md border-l border-gray-100 ${
                      !this.props.checkoutMode && "cursor-pointer"
                    }`}
                    style={{
                      overflow: " hidden",
                      height: "auto",
                      width: this.props.checkoutMode
                        ? "80px"
                        : Capacitor.getPlatform() == "ios"
                        ? "130px"
                        : "115px",
                      minWidth: this.props.checkoutMode
                        ? "80px"
                        : Capacitor.getPlatform() == "ios"
                        ? "130px"
                        : "115px",

                      position: "relative",
                      borderTopLeftRadius: 0,
                      borderBottomLeftRadius: 0,
                      minHeight: this.props.compact ? "80px" : "115px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        backgroundImage: `url(${
                          this.props.meal.platedImageURL
                            ? this.props.meal.platedImageURL
                            : this.props.meal.imageURL
                        })`,
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: this.props.meal?.platedImageURL
                          ? "150%"
                          : "240%",
                        position: "absolute",
                        left: 0,
                        top: 0,
                      }}
                    ></div>
                    <div
                      style={{
                        position: "absolute",

                        width: 24,
                        height: 24,
                      }}
                      className="text-right bg-white border-[1px] border-gray-800 rounded-md right-1 bottom-1"
                    >
                      <img
                        src={this.getProteinIcon(this.props.meal)}
                        style={{ width: "24px", position: "relative", top: -1 }}
                      ></img>
                    </div>
                    <div
                      className="absolute top-1 border-[1px] border-gray-800 text-gray-400 font-[19px] right-1 h-[24px] w-[24px] flex justify-center items-center text-gray-800 bg-white rounded-md font-weight-bold text-uppercase"
                      style={{
                        lineHeight: 1,
                      }}
                    >
                      <IonIcon
                        className="text-gray-800"
                        icon={information}
                      ></IonIcon>
                    </div>

                    {this.props.meal?.spicy ? (
                      <div className="absolute border-[1px] border-red-500 left-1 bottom-1 h-[24px] w-[24px] flex justify-center items-center bg-white rounded-md">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="140px"
                          height="185px"
                          viewBox="0 0 140 185"
                          version="1.1"
                          className="h-[15px]"
                        >
                          <title>Meal Heat Flame</title>
                          <g
                            id="Meal-Heat-Flame"
                            stroke="none"
                            stroke-width="1"
                            fill="none"
                            fill-rule="evenodd"
                          >
                            <path
                              d="M107.681558,0.0427138334 C107.659186,0.0643153614 107.637728,0.0869484654 107.617246,0.110547115 C90.7193105,5.68520951 77.1764537,22.2532462 69.8716471,40.7059469 C62.8424875,58.4622994 61.7742218,77.9317946 69.2919377,91.4332384 C58.843956,92.1203807 50.0433588,89.4909601 45.1373211,81.8453565 C39.9927803,73.8280793 38.8693021,60.0655214 45.0084773,38.4619868 C45.11997,38.0538801 44.9963276,37.6145904 44.6918305,37.3369706 C44.3873335,37.0593508 43.9576496,36.994155 43.5914148,37.170005 C9.18969463,55.8789305 -4.47664656,92.8150112 1.27256306,125.092861 C7.02172892,157.370712 32.2868081,185 74.9602098,185 C94.77662,185 111.592939,177.831255 123.140599,164.532188 C134.688259,151.233341 140.928016,131.844035 139.887794,107.685035 C138.843459,80.1224131 125.131181,67.2739748 114.895824,54.5777429 C109.778168,48.2296489 105.567777,41.903777 103.945745,33.770038 C102.323714,25.636321 103.289933,15.5507234 108.905486,1.53852578 C109.072021,1.15188858 109.010228,0.698295065 108.747234,0.376870473 C108.48424,0.0554458807 108.068124,-0.0750500267 107.681558,0.0426697859 L107.681558,0.0427138334 Z"
                              id="Path"
                              fill="#F5365C"
                            ></path>
                          </g>
                        </svg>
                      </div>
                    ) : null}
                  </div>
                </div>
              </IonCardContent>
            </IonCard>
          </>
        ) : (
          <>
            <IonCard
              mode="ios"
              className="shadow m-0 border-[1px] border-gray-100"
            >
              <IonCardContent
                className={`text-center p-0 ${
                  !this.props.checkoutMode && "cursor-pointer"
                }`}
              >
                <div
                  style={{
                    flexGrow: 1,
                    borderTopLeftRadius: "4px",
                    borderTopRightRadius: "4px",
                    position: "relative",
                    background: "var(--primary-superlight)",
                  }}
                  className="p-0 border-bottom"
                  onClick={() => this.openMealInfo(this.props.meal)}
                >
                  <div
                    style={{
                      position: "absolute",
                      right: "0.5rem",
                      bottom: "0.25rem",
                      background: "var(--primary-darker)",
                      height: 24,
                      width: 24,
                      borderRadius: "100%",
                    }}
                    className="text-right"
                  >
                    <img src={glutenFree} style={{ width: "24px" }}></img>
                  </div>
                  <div
                    className="meal-info-image"
                    style={{
                      width: "100%",
                      backgroundImage: `url(${
                        this.props.meal.platedImageURL
                          ? this.props.meal.platedImageURL
                          : this.props.meal.imageURL
                      })`,
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover",
                    }}
                  ></div>
                  <div
                    className=""
                    style={{
                      position: "absolute",
                      left: "0.5rem",
                      bottom: "0.5rem",
                    }}
                  >
                    {this.renderTopCategory(this.props.meal)}
                  </div>
                </div>
              </IonCardContent>
              <IonCardContent
                className={`px-2 pb-0 pt-2 ${
                  !this.props.checkoutMode && "cursor-pointer"
                }`}
                onClick={() => this.openMealInfo(this.props.meal)}
              >
                <IonRow>
                  <IonCol size-xs="12" className="text-left">
                    <div
                      className={`meal-info-container  ${
                        !this.props.checkoutMode && "cursor-pointer"
                      }`}
                    >
                      <h2
                        className="mb-1 meal-info-title text-dark font-weight-bold text-center"
                        style={{ fontSize: 18 }}
                      >
                        {this.props.meal.name}
                      </h2>
                      <div className="meal-info-description text-center">
                        {this.convertToPlain(this.props.meal.description)}
                      </div>

                      {/*<p style={{fontSize: '14px', lineHeight: 1.25}} className="mb-2 text-dark">example description summary goes here with some more words</p>*/}
                    </div>
                  </IonCol>
                </IonRow>
              </IonCardContent>
              <IonCardContent className="px-2 pt-0 pb-2">
                <IonRow className="ion-justify-content-center ion-align-items-center">
                  <IonCol size-xs="12" size-xl="auto" className="py-xl-0">
                    <div
                      className={`${
                        !this.props.checkoutMode && "cursor-pointer"
                      }`}
                      onClick={() => this.openMealInfo(this.props.meal)}
                    >
                      <IonRow className="ion-justify-content-center ion-justify-content-xl-left">
                        <IonCol
                          size-xs="auto"
                          className="py-0 pl-0 pr-3 text-center text-xl-left"
                        >
                          <p
                            style={{ fontSize: 16 }}
                            className="text-lowercase text-dark font-weight-bold mb-0 meal-info-nutrition"
                          >
                            {this.props.meal.nutrition.calories}
                          </p>
                          <p
                            className="text-uppercase text-dark font-weight-bold m-0"
                            style={{ fontSize: "11px" }}
                          >
                            Cal
                          </p>
                        </IonCol>
                        <IonCol
                          size-xs="auto"
                          className="py-0 pl-0 pr-3 text-center text-xl-left"
                        >
                          <p
                            style={{ fontSize: 16 }}
                            className="text-lowercase text-dark font-weight-bold mb-0 meal-info-nutrition"
                          >
                            {this.props.meal.nutrition.protein}g
                          </p>
                          <p
                            className="text-uppercase text-dark font-weight-bold m-0"
                            style={{ fontSize: "11px" }}
                          >
                            Protein
                          </p>
                        </IonCol>
                        <IonCol
                          size-xs="auto"
                          className="border-right py-0 pl-0 pr-3 text-center text-xl-left"
                        >
                          <p
                            style={{ fontSize: 16 }}
                            className="text-lowercase text-dark font-weight-bold mb-0 meal-info-nutrition"
                          >
                            {this.props.meal.nutrition.carbs}g
                          </p>
                          <p
                            className="text-uppercase text-dark font-weight-bold m-0"
                            style={{ fontSize: "11px" }}
                          >
                            Carbs
                          </p>
                        </IonCol>
                        <IonCol
                          size-xs="auto"
                          className="pl-0 pr-0 py-0 text-center text-xl-left"
                        >
                          <p
                            style={{ fontSize: 16 }}
                            className="text-lowercase text-dark font-weight-bold mb-0 meal-info-nutrition"
                          >
                            {this.props.meal.nutrition.fat}g
                          </p>
                          <p
                            className="text-uppercase text-dark font-weight-bold m-0"
                            style={{ fontSize: "11px" }}
                          >
                            Fats
                          </p>
                        </IonCol>
                      </IonRow>
                    </div>
                  </IonCol>
                </IonRow>
              </IonCardContent>
            </IonCard>
          </>
        )}
      </>
    );
  }
}

export default MealOptionCardNoSelection;
